import styled from 'styled-components';

const CartContainerView = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  & > div {
    &:first-of-type {
      width: 67%;
      margin-right: 3%;
    }
    &:last-of-type {
      width: 30%;
    }
  }
  @media (max-width: 900px) {
    & > div:first-of-type {
      width: 100%;
      margin-right: 0;
    }
    & > div:last-of-type {
      width: 100%;
    }
  }
`;

export default CartContainerView;
